import laptop from "./img/girl-working.jpg";
import mortgage from "./img/mortgage.jpg";
import selfies from "./img/selfie.jpg";

const promoData = () => {
  return [
    {
      title: "Ready to make ever dollar count",
      desc:
        " Get a 2.10% savings rate when you open your first Savings and Chequing Accounts. Plus, you could earn $150*.",
      img: laptop,
      button: "Save With 2.5%",
      index: 0,
    },

    {
      title: "A mortgage rate to brag about",
      desc: "Get a 5 year fixed rate of 1.74% / 1.76% APR*.",
      img: mortgage,
      button: "Great Mortgage Rates",
      index: 1,
    },

    {
      title: "As easy as taking a selfie",
      desc:
        "Introducing our new digital signup—available on the Mazuma Mobile Banking app.",
      img: selfies,
      button: "Easy Sign Up",
      index: 2,
    },
  ];
};

export default promoData;
